import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default from 'react';
import { Address } from './atoms/address-container.esm.js';
import { CompanyWebsite } from './atoms/company-website.esm.js';
import { ContactName } from './atoms/contact-name.esm.js';
import { ContactTitleAndCompany } from './atoms/contact-title-and-company.esm.js';
import { Phone } from './atoms/phone-container.esm.js';
import { ObfuscationSkeletonContact } from './obfuscation-skeleton.esm.js';

/**
 * @description
 * **Component that defines a vertical arrangement of the contact card for contact detail pages**
 *
 * @property {ContactCardData} **data**: Data about the contact
 * @property {Object} **messages**: Messages passed in for the contact card
 */
var RightRailContactCard = function RightRailContactCard(_ref) {
  var data = _ref.data,
    messages = _ref.messages,
    showObfuscationSkeleton = _ref.showObfuscationSkeleton,
    contactImageComponent = _ref.contactImageComponent,
    companyLinkComponent = _ref.companyLinkComponent,
    iconsComponent = _ref.iconsComponent;
  if (!data) return null;
  var name = data.name,
    title = data.title,
    company = data.company,
    address = data.address,
    phone = data.phone,
    companyWebsiteUrl = data.companyWebsiteUrl,
    companyWebsiteLabel = data.companyWebsiteLabel;
  return /*#__PURE__*/React__default.createElement("section", {
    "automation-id": "right-rail-contact-card",
    className: "lg:sticky lg:top-4"
  }, /*#__PURE__*/React__default.createElement("figure", {
    className: "h-max w-full border border-[#bfbfbf] p-6 font-sans text-p-16/5 font-normal shadow-[2px_6px_4px_0px_rgba(0,0,0,0.20)] lg:max-w-[300px]"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col gap-6 sm:flex-row lg:flex-col"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "size-[160px] shrink-0 sm:max-lg:col-start-1 sm:max-lg:row-span-2"
  }, contactImageComponent), /*#__PURE__*/React__default.createElement("figcaption", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col gap-2 sm:max-lg:col-start-2"
  }, /*#__PURE__*/React__default.createElement(ContactName, name), /*#__PURE__*/React__default.createElement(ContactTitleAndCompany, {
    title: title,
    company: company,
    companyLinkComponent: companyLinkComponent
  })), !showObfuscationSkeleton ? /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col gap-1 sm:max-lg:gap-2"
  }, /*#__PURE__*/React__default.createElement(Address, {
    address: address
  }), /*#__PURE__*/React__default.createElement(Phone, _extends({}, phone, {
    messages: messages
  })), iconsComponent, companyWebsiteUrl && companyWebsiteLabel && /*#__PURE__*/React__default.createElement(CompanyWebsite, {
    websiteUrl: companyWebsiteUrl,
    websiteLabel: companyWebsiteLabel
  })) : /*#__PURE__*/React__default.createElement(ObfuscationSkeletonContact, null)))));
};

export { RightRailContactCard };
//# sourceMappingURL=right-rail-contact-card.esm.js.map
